import React, { createContext, useReducer } from 'react';
// import { IStoreState } from 'src/@infringements/props';
import { dataInitialState, dataReducer } from 'src/@infringements/reducers/dataReducer';
import { sortInitialState, sortReducer } from 'src/@infringements/reducers/sortReducer';
import { tagDataReducer } from 'src/app/reducers/tagDataReducer';
import { tagDataInitialState } from 'src/app/reducers/initialStates';

export const InfringementStateContext = createContext({
  data: dataInitialState,
  sort: sortInitialState,
});

export const InfringementDispatchContext = createContext(null);

export const InfringementsStateProvider = ({ children }) => {
  const [dataState, dataDispatch] = useReducer<any>(dataReducer, dataInitialState);
  const [sortState, sortDispatch]: any = useReducer<any>(sortReducer, sortInitialState);
  const [tagDataState, tagDataDispatch]: any = useReducer<any>(tagDataReducer, tagDataInitialState);

  const state: any = {
    data: dataState,
    sort: sortState,
    tagData: tagDataState,
  };

  const dispatchers = [dataDispatch, sortDispatch, tagDataDispatch];

  const dispatch: any = (action: any) =>
    dispatchers.map((dispatcher: any) => {
      dispatcher(action);
    });

  return (
    <InfringementStateContext.Provider value={state}>
      <InfringementDispatchContext.Provider value={dispatch}>
        {children}
      </InfringementDispatchContext.Provider>
    </InfringementStateContext.Provider>
  );
};
